/**
 * Curated list of 1000+ clean, appropriate Latin words for anonymized username generation.
 * Words are in PascalCase, kept short (2–12 chars), and cover nature, virtues,
 * animals, celestial bodies, elements, knowledge, and more.
 *
 * Two words are combined with a 2–3 digit number to form usernames like:
 *   AquilaFortis42, LuxAeterna217, VentusAureus8
 */
const LATIN_WORDS = [
  // ── Nature & Elements ──
  "Aqua", "Terra", "Ignis", "Ventus", "Aer", "Aether", "Natura", "Silva",
  "Arbor", "Flos", "Herba", "Folium", "Ramus", "Radix", "Lignum", "Cortex",
  "Mons", "Collis", "Vallis", "Campus", "Prata", "Ager", "Arvum", "Hortus",
  "Mare", "Oceanus", "Flumen", "Rivus", "Fons", "Lacus", "Unda", "Petra",
  "Saxum", "Lapis", "Arena", "Humus", "Caelum", "Nubes", "Pluvia", "Imber",
  "Nix", "Glacies", "Gelu", "Pruina", "Fulmen", "Nebula", "Ros", "Aura",
  "Tempestas", "Procella", "Pratum", "Spuma", "Gramen", "Seges", "Messis",
  "Iridis", "Truncus", "Stagnum", "Argilla",

  // ── Celestial & Time ──
  "Sol", "Luna", "Stella", "Sidus", "Astra", "Astrum", "Aurora", "Vesper",
  "Polaris", "Orion", "Meridies", "Nox", "Dies", "Tempus", "Hora", "Annus",
  "Aevum", "Aetas", "Ver", "Aestas", "Autumnus", "Hiems", "Saeculum",
  "Cometa", "Galaxia", "Eclipsis", "Arcturus", "Sirius", "Mensis",
  "Crepusculum",

  // ── Animals ──
  "Leo", "Lupus", "Ursus", "Vulpes", "Canis", "Felis", "Equus", "Taurus",
  "Cervus", "Capra", "Ovis", "Aper", "Lepus", "Lynx", "Pardus", "Tigris",
  "Elephas", "Camelus", "Delphinus", "Aquila", "Accipiter", "Corvus",
  "Columba", "Passer", "Cygnus", "Ardea", "Ciconia", "Grus", "Pavo",
  "Falco", "Merula", "Luscinia", "Bubo", "Noctua", "Piscis", "Salmo",
  "Testudo", "Serpens", "Draco", "Lacerta", "Rana", "Nautilus", "Apis",
  "Formica", "Cicada", "Papilio", "Aranea", "Scarabaeus", "Milvus",
  "Perdix", "Hirundo", "Alcedo", "Vultur", "Fiber", "Phoca", "Bos",
  "Agnus", "Catulus", "Anser", "Anas",

  // ── Colors ──
  "Albus", "Niger", "Ruber", "Viridis", "Flavus", "Aureus", "Argenteus",
  "Purpureus", "Roseus", "Fuscus", "Candidus", "Rufus", "Croceus", "Fulvus",
  "Eburneus", "Coccineus", "Ceruleus", "Ater", "Luteus", "Niveus",

  // ── Metals & Minerals ──
  "Aurum", "Argentum", "Ferrum", "Cuprum", "Stannum", "Aes", "Adamans",
  "Gemma", "Crystallus", "Beryllus", "Smaragdus", "Sapphirus", "Topazius",
  "Margarita", "Calybs", "Orichalcum",

  // ── Virtues & Positive Qualities ──
  "Virtus", "Fortitudo", "Veritas", "Fides", "Spes", "Caritas", "Pax",
  "Concordia", "Iustitia", "Prudentia", "Clementia", "Pietas", "Dignitas",
  "Gravitas", "Constantia", "Integritas", "Honos", "Gloria", "Laus",
  "Decus", "Nobilitas", "Liberalitas", "Humanitas", "Aequitas", "Probitas",
  "Sanctitas", "Benevolentia", "Magnificentia",

  // ── Knowledge & Wisdom ──
  "Scientia", "Sapientia", "Doctrina", "Eruditio", "Cognitio", "Intellectus",
  "Ratio", "Mens", "Ingenium", "Studium", "Litterae", "Ars", "Peritia",
  "Solertia", "Acumen", "Sagacitas", "Disciplina", "Experientia", "Notitia",
  "Perspicacia", "Mathesis",

  // ── Strength & Power ──
  "Potentia", "Potestas", "Vis", "Robur", "Validus", "Valens", "Potens",
  "Strenuus", "Ferox", "Audax", "Acer", "Solidus", "Firmus", "Stabilis",
  "Tenax", "Vehemens", "Robustus",

  // ── Size & Magnitude ──
  "Magnus", "Maximus", "Grandis", "Ingens", "Vastus", "Amplus", "Altus",
  "Celsus", "Sublimis", "Longus", "Latus", "Profundus", "Summus", "Largus",
  "Brevis",

  // ── Speed & Motion ──
  "Velox", "Celer", "Rapidus", "Alacer", "Pernix", "Agilis", "Mobilis",
  "Volucris", "Cursus", "Impetus", "Gradus", "Festinus", "Citus",

  // ── Light & Radiance ──
  "Lux", "Lumen", "Splendor", "Fulgor", "Nitor", "Jubar", "Radius",
  "Candor", "Lampas", "Flamma", "Clarus", "Lucidus", "Lucens", "Nitidus",
  "Fulgur",

  // ── Beauty & Aesthetics ──
  "Pulcher", "Formosus", "Venustus", "Decorus", "Elegans", "Speciosus",
  "Forma", "Gratia", "Venustas", "Amoenus", "Suavis", "Bellus",

  // ── Joy & Emotion ──
  "Laetus", "Felix", "Beatus", "Hilaris", "Gaudium", "Laetitia",
  "Felicitas", "Iucundus", "Gratus", "Hilarus", "Delectatio",

  // ── Victory & Achievement ──
  "Victor", "Victrix", "Victoria", "Triumphus", "Palma", "Invictus",
  "Praestans", "Excellens", "Eximius", "Egregius", "Insignis", "Illustris",
  "Nobilis", "Gloriosus", "Trophaeum", "Vincens",

  // ── Action & Craft ──
  "Faber", "Factor", "Creator", "Conditor", "Artifex", "Opifex", "Auctor",
  "Rector", "Dux", "Princeps", "Custos", "Defensor", "Liberator", "Vindex",
  "Inventor", "Navigator", "Explorator", "Venator", "Repertor", "Iudex",
  "Arbiter",

  // ── Roles & Occupations ──
  "Rex", "Regina", "Consul", "Senator", "Civis", "Miles", "Nauta",
  "Agricola", "Pastor", "Poeta", "Scriptor", "Pictor", "Medicus",
  "Magister", "Discipulus", "Philosophus", "Rhetor", "Musicus", "Cantor",
  "Sculptor", "Architectus", "Imperator",

  // ── Character Traits ──
  "Liber", "Iustus", "Probus", "Sanctus", "Purus", "Integer", "Sincerus",
  "Simplex", "Verus", "Certus", "Fidelis", "Constans", "Sapiens", "Prudens",
  "Peritus", "Doctus", "Fortis", "Castus", "Gravis",

  // ── Abstract Concepts ──
  "Vita", "Anima", "Animus", "Spiritus", "Corpus", "Ortus", "Fortuna",
  "Fatum", "Amor", "Amicus", "Socius", "Comes", "Frater", "Soror",
  "Genus", "Stirps", "Memoria", "Sensus", "Voluntas", "Consilium",
  "Eventus", "Sors", "Proles",

  // ── Speech & Communication ──
  "Vox", "Verbum", "Sermo", "Lingua", "Nomen", "Nuntius", "Fama",
  "Narratio", "Carmen", "Cantus", "Fabula", "Oratio", "Dictum", "Rumor",

  // ── Buildings & Places ──
  "Domus", "Villa", "Templum", "Turris", "Arx", "Castellum", "Murus",
  "Porta", "Pons", "Via", "Iter", "Semita", "Aedes", "Fanum", "Tectum",
  "Atrium", "Forum", "Curia", "Basilica", "Circus", "Thermae",

  // ── Tools & Objects ──
  "Gladius", "Hasta", "Sagitta", "Arcus", "Scutum", "Galea", "Navis",
  "Currus", "Rota", "Codex", "Tabula", "Calamus", "Lorica", "Telum",
  "Ancora", "Signum", "Vexillum", "Tessera", "Clipeus", "Toga",

  // ── Plants & Trees ──
  "Quercus", "Fagus", "Pinus", "Abies", "Cupressus", "Laurus", "Olea",
  "Vitis", "Platanus", "Salix", "Fraxinus", "Ulmus", "Ilex", "Myrtus",
  "Cedrus", "Rosa", "Lilium", "Viola", "Crocus", "Populus", "Hedera",

  // ── Food & Agriculture ──
  "Panis", "Frumentum", "Triticum", "Oliva", "Uva", "Vinum", "Malum",
  "Pirum", "Ficus", "Mel", "Caseus", "Oleum", "Sal", "Hordeum", "Avena",
  "Faba",

  // ── Geography & Landscapes ──
  "Insula", "Littus", "Ripa", "Portus", "Sinus", "Pelagus", "Vertex",
  "Cacumen", "Iugum", "Rupes", "Scopulus", "Nemus", "Lucus", "Planities",
  "Ora", "Fretum", "Aequor", "Dorsum", "Clivus",

  // ── Sound & Music ──
  "Sonus", "Musica", "Harmonia", "Concentus", "Lyra", "Cithara", "Tuba",
  "Tympanum", "Chorus", "Hymnus", "Melodia", "Echo", "Resonans", "Canorus",
  "Susurrus", "Sonitus", "Symphonia", "Melos",

  // ── Sacred & Divine ──
  "Divinus", "Sacer", "Augustus", "Pius", "Benedictus", "Caelestis",
  "Aeternus", "Immortalis", "Venerabilis", "Devotus", "Sollemnis",

  // ── Excellence & Quality ──
  "Optimus", "Supremus", "Perfectus", "Absolutus", "Plenus", "Mundus",
  "Germanus", "Merus", "Praeclarus",

  // ── Beginning & Origin ──
  "Principium", "Initium", "Origo", "Caput", "Finis", "Terminus",
  "Exordium", "Primordium",

  // ── Directions & Winds ──
  "Oriens", "Occidens", "Aquilo", "Auster", "Zephyrus", "Boreas", "Notus",
  "Eurus", "Dexter", "Primus", "Medius", "Septentrio",

  // ── Fire & Heat ──
  "Igniculus", "Scintilla", "Favilla", "Focus", "Ardor", "Fervor",
  "Flagrans", "Ardens", "Fervens", "Incendium", "Caminus",

  // ── Water Features ──
  "Gutta", "Stilla", "Torrens", "Amnis", "Fluctus", "Fluxus", "Gurges",
  "Vortex",

  // ── Circles & Shapes ──
  "Orbis", "Spira", "Globus", "Sphaera", "Discus", "Corona", "Annulus",
  "Cyclus", "Circulus",

  // ── Growth & Flourishing ──
  "Crescens", "Incrementum", "Progressus", "Profectus", "Cultus",
  "Floridus", "Florens", "Vegetus", "Vigens", "Provectus",

  // ── Peace & Calm ──
  "Quies", "Otium", "Tranquillus", "Placidus", "Quietus", "Sedatus",
  "Pacatus", "Mitis", "Lenis", "Mansuetus", "Serenitas",

  // ── Protection & Safety ──
  "Tutela", "Praesidium", "Asylum", "Refugium", "Tutus", "Securus",
  "Salvus", "Incolumis", "Munimen",

  // ── Freedom ──
  "Libertas", "Facultas", "Copia", "Solutus", "Expeditus", "Immunitas",

  // ── Mystery & Wonder ──
  "Arcanus", "Occultus", "Abditus", "Reconditus", "Mysticus", "Mirabilis",
  "Mirus", "Latens",

  // ── Precision & Clarity ──
  "Perspicuus", "Apertus", "Evidens", "Manifestus", "Cognitus",
  "Perlucidus",

  // ── Sweetness & Pleasantness ──
  "Dulcis", "Mellitus", "Blandus", "Commodus", "Aptus", "Idoneus",
  "Opportunus",

  // ── Richness & Abundance ──
  "Dives", "Opulentus", "Copiosus", "Abundans", "Uber", "Fertilis",
  "Fecundus", "Locuples", "Affluens",

  // ── Newness ──
  "Novus", "Recens", "Novellus", "Renatus", "Renovatus", "Intactus",

  // ── Ancientness ──
  "Antiquus", "Vetus", "Priscus", "Pristinus", "Primigenius", "Vetustus",
  "Perantiquus",

  // ── Height & Depth ──
  "Altitudo", "Celsitudo", "Apex", "Culmen", "Eminentia", "Abyssus",
  "Fastigium",

  // ── Boldness & Courage ──
  "Animosus", "Intrepidus", "Impavidus", "Confidens", "Erectus",
  "Pertinax",

  // ── Wholeness & Unity ──
  "Unitas", "Universitas", "Consensus", "Nexus", "Vinculum", "Nodus",

  // ── Philosophical ──
  "Logos", "Ethos", "Praxis", "Thesis", "Modus", "Locus", "Status",
  "Habitus", "Essentia", "Substantia",

  // ── Additional Adjectives ──
  "Benignus", "Levis", "Serenus", "Placens", "Lustralis", "Modestus",
  "Facilis", "Utilis", "Salubris", "Frugalis", "Calidus", "Frigidus",
  "Gelidus", "Tepidus", "Humidus", "Siccus", "Glaber", "Politus",
  "Rectus", "Curvus", "Densus", "Tener", "Gracilis", "Subtilis",

  // ── Additional Nouns ──
  "Pharus", "Monile", "Fibula", "Pileus", "Stola", "Opus", "Index",
  "Matrix", "Calx", "Crista", "Clavis", "Rostrum", "Pensum", "Fundus",
  "Margo", "Limen", "Zenith", "Nadir", "Axis", "Basis", "Crux",
  "Umbra", "Funis", "Catena", "Serra", "Malleus", "Incus",
  "Acus", "Filum", "Tela", "Rete", "Cuneus", "Clavus",

  // ── Roman Life & Culture ──
  "Senatus", "Plebs", "Tribus", "Legio", "Cohors", "Centurio", "Praefectus",
  "Quaestor", "Praetor", "Aedilis", "Tribunus", "Legatus", "Propraetor",
  "Dictator", "Censor", "Pontifex", "Augur", "Vestalis", "Lictor",
  "Scriba", "Cursor", "Viator", "Praeco", "Tabellarius",

  // ── Astronomy & Constellations ──
  "Perseus", "Centaurus", "Pegasus", "Andromeda", "Cassiopeia", "Lyrae",
  "Cepheus", "Hydra", "Phoenix", "Corvidae", "Crater", "Fornax",
  "Volans",

  // ── Body of Knowledge ──
  "Geometria", "Rhetorica", "Grammatica", "Logica", "Astronomia",
  "Arithmetica", "Dialectica", "Historia", "Poesis", "Physica",
  "Metaphysica", "Ethica", "Politica", "Botanica", "Medicina",

  // ── Emotions & States (Positive) ──
  "Fiducia", "Alacritas", "Voluptas", "Exultatio", "Jubilatio",
  "Securitas", "Contentus",

  // ── Cosmic & Grand ──
  "Cosmos", "Universum", "Infinitus", "Perpetuus", "Sempiternus",
  "Omnipotens", "Immensus", "Illimitus",

  // ── Treasures & Wealth ──
  "Thesaurus", "Pretium", "Donum", "Munus", "Praemium", "Beneficium",
  "Fructus", "Lucrum",

  // ── Seasons & Weather Extended ──
  "Solstitium", "Aequinoctium", "Diluculum", "Caligo",

  // ── Maritime ──
  "Velum", "Remus", "Prora", "Puppis", "Gubernator",
  "Classis", "Triremis", "Portitor", "Litus",

  // ── Terrain & Earth ──
  "Caverna", "Spelunca", "Antrum", "Crypta", "Barathrum",
  "Desertum", "Oasis", "Palus",

  // ── Precious & Rare ──
  "Electrum", "Ambra", "Corallium", "Onyx", "Iaspis", "Carbunculus",
  "Achates",

  // ── Architecture Elements ──
  "Columna", "Cupola", "Fornix", "Vestibulum",
  "Peristylium", "Impluvium", "Compluvium",

  // ── Textiles & Materials ──
  "Linum", "Sericeum", "Lana", "Bombyx", "Purpura", "Corium",
  "Papyrus", "Pergamenum",

  // ── Garden & Cultivation ──
  "Viridarium", "Pomarium", "Rosetum", "Vinea", "Seminarium", "Vivarium",
  "Apiarium", "Herbarium",

  // ── Philosophy Concepts ──
  "Summum", "Principia", "Auctoritas", "Decorum", "Officium",

  // ── More Animals ──
  "Panthera", "Cetus", "Basiliscus", "Gryphus", "Unicornis",
  "Salamandra", "Chamaeleon", "Ibis", "Pelicanus", "Sturnus",

  // ── Additional Verbs/Participles (as names) ──
  "Lector", "Candens", "Micans", "Fulgens",
  "Nitens", "Spirans", "Fluens", "Manans", "Surgens",
  "Natans", "Regnans",

  // ── Additional Words to reach 1000+ ──
  "Aequus", "Clypeus", "Sceptrum", "Diadema", "Regnum", "Thronus",
  "Titanis", "Olympus", "Parnassus", "Helicon", "Elysium", "Arcadia",
  "Templar", "Palatium", "Capitolium", "Colosseum",
  "Mercator", "Negotiator", "Fundator", "Propagator", "Moderator",
  "Praedicator", "Legionarius", "Eques", "Praetorius",
  "Sapor", "Odor", "Tactus", "Visus", "Auditus",
  "Cauda", "Ala", "Penna", "Pluma", "Squama", "Cornu", "Ungula",
  "Iuba", "Pellis", "Vellus",
  "Prunus", "Malus", "Persica", "Morus", "Nucula", "Glans",
  "Spica", "Calyx", "Petala", "Stamen", "Pollen",
  "Rivulus", "Cascata", "Paludes", "Emissarium",
  "Solaris", "Lunaris", "Stellaris", "Astralis", "Borealis",
  "Australis", "Orientalis", "Caeruleum",
  "Mythicus", "Legendarius", "Fabulosus", "Heroicus", "Epicus",
  "Titanicus", "Colossalis",
  "Auriga", "Opilio", "Bubulcus", "Sutor", "Textor", "Figulus",
  "Tonsor", "Pistor", "Caupo", "Institor",
  "Praeses", "Patronus", "Dominus", "Magnas", "Optimatus",
  "Principalis", "Regalis", "Imperialis",
  "Sidereus", "Ethereus", "Olympicus", "Herculeus",
  "Marmoreus", "Crystallinus", "Adamantinus",
  "Tempestivus", "Matutinus", "Vespertinus", "Nocturnus", "Diurnus",
  "Vernalis", "Aestivalis", "Autumnalis", "Hibernalis",
];

export default LATIN_WORDS;
